// ═══ 검차 셸 라우트 — Dashboard 가 /main/* 에 마운트되므로 여기 path 는 'main' 기준 상대 ═══
// 라우트 6개(BUILD_PLAN §1). 그 외 /main/* 경로는 /main/s/home 으로 되돌린다(검차 셸에는 이 라우트만 존재 — 앱과 동일).
// 단 차량관리 허용 경로(isManagePath)는 이 라우트에 오지 않는다 — Dashboard 래퍼가 크롬 변형(SimpleChrome)으로 연다.
import React from 'react';
import { Routes, Route, Navigate, useParams } from 'react-router-dom';
import { SimpleHome, SimpleRequests, SimpleRequestDetail, SimpleNewRequest, SimpleFees, SimpleMore } from './screens';
import { useIsDesktop } from './useDesktop';
import { V2_MENUS, navIdOf } from '../menus';

export var SIMPLE_HOME = '/main/s/home';

// 탭 5개 — 셸 상단(데스크톱) / 하단(모바일) 공용.
export var SIMPLE_TABS = [
  { id: 'home', to: '/main/s/home', labelKey: 'shellTabHome' },
  { id: 'requests', to: '/main/s/requests', labelKey: 'shellTabEval' },
  { id: 'fees', to: '/main/s/fees', labelKey: 'shellTabSettlement' },
  { id: 'manage', to: '/main/car-list', labelKey: 'shellTabManage' },
  { id: 'more', to: '/main/s/more', labelKey: 'shellTabMore' }
];

// '차량관리' 탭 = 차량관리 화면을 URL 그대로(/main/<id>) 검차 셸 크롬 안에서 연다 — Dashboard.js 래퍼가 isManagePath 로 분기.
// 2차 바 항목 = 수출업체 메뉴(V2_MENUS)에서 대시보드·검차 제외 6개. 관리자도 같은 6개 (Jin 2026-10-07).
export var MANAGE_ITEMS = [];
V2_MENUS.forEach(function (s) {
  s.items.forEach(function (i) { if (i.id !== 'dashboard' && i.id !== 'eval') MANAGE_ITEMS.push({ id: i.id, label: i.label }); });
});

/// 크롬 변형으로 여는 경로 — 6개 + 그 하위(그룹 탭·면장 수신함 = navIdOf 가 6개 중 하나로 접는 id) + 서류 보기.
/// 그 밖의 /main/*(대시보드·검차·리포트…)는 검차 셸 catch-all 이 /main/s/home 으로 되돌린다.
export function isManagePath(pathname) {
  var m = /^\/main\/([^/]+)/.exec(String(pathname || ''));
  if (!m) return false;
  var id = navIdOf(m[1]);
  return m[1] === 'doc-view' || MANAGE_ITEMS.some(function (i) { return i.id === id; });
}

/// 현재 경로 → 활성 탭 id. 신청 3단계(/s/request)는 검차 탭 소속으로 본다.
export function tabIdOf(pathname) {
  var p = String(pathname || '');
  if (isManagePath(p)) return 'manage';
  if (p.indexOf('/main/s/fees') === 0) return 'fees';
  if (p.indexOf('/main/s/more') === 0) return 'more';
  if (p.indexOf('/main/s/request') === 0) return 'requests';
  return 'home';
}

/// 검차 셸 경로인가 — '/main/s' 또는 '/main/s/…' 만 ('/main/settings' 는 아니다).
export function isSimplePath(pathname) {
  var p = String(pathname || '');
  return p === '/main/s' || p.indexOf('/main/s/') === 0;
}

// 데스크톱(≥1024) 의 /s/requests/:id 는 2-pane 목록 화면이 그대로 산다 — 우측 상세만 :id 로 갱신된다
// (SimpleRequests 가 useParams().id 를 읽는다). ≤1023 은 기존대로 상세 페이지로 이동.
function RequestsOrDetail(props) {
  var isDesktop = useIsDesktop();
  var id = useParams().id;
  return (isDesktop || !id) ? <SimpleRequests {...props} /> : <SimpleRequestDetail {...props} />;
}

function SimpleRoutes(props) {
  var p = { user: props.user, screenMode: props.screenMode };
  return (<Routes>
    <Route path="s" element={<Navigate to={SIMPLE_HOME} replace />} />
    <Route path="s/home" element={<SimpleHome {...p} />} />
    {/* 두 경로가 같은 element 타입이어야 목록 → 첫 행 클릭 시 remount(목록 재조회·로딩 깜빡임)가 없다 */}
    <Route path="s/requests" element={<RequestsOrDetail {...p} />} />
    <Route path="s/requests/:id" element={<RequestsOrDetail {...p} />} />
    <Route path="s/request" element={<SimpleNewRequest {...p} />} />
    <Route path="s/fees" element={<SimpleFees {...p} />} />
    <Route path="s/more" element={<SimpleMore {...p} onLogout={props.onLogout} />} />
    <Route path="*" element={<Navigate to={SIMPLE_HOME} replace />} />
  </Routes>);
}

export default SimpleRoutes;
